import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';
import { CURRENCY_2 } from 'commons-vehicle/constants/currencyFormats.js';

import './PaymentDetailRebate.scss';

const CONTENT_ZONE_GROUP = {
    LISTING: 'widget.listing.used',
    VDP: 'widget.build.and.buy',
};

const getDealerRebateLabel = (isUsed) => {
    const contentZoneName = 'dealer.rebate.label';
    let dealerRebateLabel = ContentZonesService.getContentZone(CONTENT_ZONE_GROUP.LISTING, contentZoneName);

    if (isUsed) {
        dealerRebateLabel =
            ContentZonesService.getContentZone(CONTENT_ZONE_GROUP.LISTING, `${contentZoneName}.used`) ||
            dealerRebateLabel;
    }
    if (!dealerRebateLabel || !dealerRebateLabel.getText()) {
        dealerRebateLabel = ContentZonesService.getContentZone(CONTENT_ZONE_GROUP.VDP, contentZoneName);
    }
    return (dealerRebateLabel && dealerRebateLabel.getText()) || '';
};

const PaymentDetailRebate = ({ amount, i18nKey, data, iconClass, isUsed }) => {
    const currentClass = [iconClass, 'is-primary'];
    return (
        <div className="payment-rebate" {...data}>
            <div className="rebate-title">
                <icon className={currentClass.join(' ')} />
                <span>
                    {i18nKey === 'PAYMENTS_REBATES.DEALER_REBATE'
                        ? getDealerRebateLabel(isUsed) || LocaleService.t(i18nKey)
                        : LocaleService.t(i18nKey)}
                </span>
            </div>
            {amount && (
                <div className="rebate-amount is-bold">
                    <span>{LocaleService.l(amount, CURRENCY_2)}</span>
                </div>
            )}
        </div>
    );
};

PaymentDetailRebate.defaultProps = {
    amount: null,
    isUsed: false,
};

PaymentDetailRebate.propTypes = {
    amount: PropTypes.number,
    i18nKey: PropTypes.string.isRequired,
    data: PropTypes.shape({
        'sr-data': PropTypes.string,
    }).isRequired,
    iconClass: PropTypes.string.isRequired,
    isUsed: PropTypes.bool,
};

PaymentDetailRebate.displayName = 'PaymentDetailRebate';

export default PaymentDetailRebate;
